
































































































































































































import { Component, Vue } from 'vue-property-decorator';
import AdminIndex from '../admin/index.vue';
@Component({})
export default class Manual extends Vue {}
